import { IJsonQuery } from '@cian/api-models/common/json_query';

const imageDefault: string = require('./assets/default.jpg');
const imageNN: string = require('./assets/nn.jpg');
const imageKazan: string = require('./assets/kazan.jpg');

export interface ICustomBackground {
  conditions(jsonQuery: IJsonQuery): boolean;
  image: string;
}

const CUSTOM_BACKGROUNDS: ICustomBackground[] = [
  {
    conditions: containsRegion([ 4596, 4885 ]),
    image: imageNN,
  },
  {
    conditions: containsRegion([ 4618, 4777 ]),
    image: imageKazan,
  },
];

export function getCustomBackground(jsonQuery: IJsonQuery): string {
  const customBackground = CUSTOM_BACKGROUNDS.find((e) => e.conditions(jsonQuery));

  return customBackground && customBackground.image || imageDefault;
}

export function containsRegion(regions: number[]): (jsonQuery: IJsonQuery) => boolean {
  return (jsonQuery) => {
    // tslint:disable-next-line: no-non-null-assertion
    return jsonQuery.region && regions.some((region) => jsonQuery.region!.value.includes(region)) || false;
  };
}
